import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md q-card column justify-between",
  style: {"width":"700px","max-width":"80vw"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "q-mb-sm text-weight-bold" }, "Are you sure you want immediately and PERMANENTLY close this access?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-body1" }, "This access will NOT BE SEEN on invoice", -1)
const _hoisted_4 = { class: "q-gutter-md q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h6", null, "Member: " + _toDisplayString(_ctx.member.name), 1),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_btn, {
            color: "primary",
            label: "No",
            onClick: _ctx.onCancelClick,
            outline: "",
            "no-caps": "",
            unelevated: ""
          }, null, 8, ["onClick"]),
          _createVNode(_component_q_btn, {
            color: "negative",
            label: "Yes remove",
            onClick: _ctx.onMemberPurge,
            "no-caps": ""
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}